interface ILoginUserData {
    email: string;
    password: string;
    recaptchaToken: string;
}

export const NewLoginUserData: ILoginUserData = {
    email: "",
    password: "",
    recaptchaToken: ""
};

export default ILoginUserData;
